import { IParser, ParserId } from "./IParser";
import { parseCsharp } from "./parseCsharp";
import { parseCsv } from "./parseCsv";
import { parseJson } from "./parseJson";
import { parseSql } from "./parseSql";
import { parseTypescript } from "./parseTypescript";

export interface IParserService {
    getParsers(): IParser[]
}

export class ParserService implements IParserService {
    getParsers(): IParser[] {
        return [
            { id: ParserId.Json, name: "JSON", parseChunk: parseJson },
            { id: ParserId.Csv, name: "CSV", parseChunk: parseCsv },
            { id: ParserId.Csharp, name: "C#", parseChunk: parseCsharp },
            { id: ParserId.Typescript, name: "Typescript", parseChunk: parseTypescript },
            { id: ParserId.Sql, name: "SQL", parseChunk: parseSql },
        ];
    }
}